import { supabase } from '../lib/supabaseClient';

export async function fetchGroups() {
  try {
    const { data, error } = await supabase
      .from('groups')
      .select('id, name, website_id, image_url')
      .order('name');

    if (error) {
      console.error('Error fetching groups:', error);
      return [];
    }

    return data || [];
  } catch (error) {
    console.error('Error fetching groups:', error);
    return [];
  }
}
